import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from "luxon";

@Pipe({
    name: 'getMonthOfawsDate'
})
export class GetMonthOfawsDatePipe implements PipeTransform {

    transform(value: string): unknown {
        if (!value)
            return "";

        let month = "";
        switch (DateTime.fromISO(value).month) {
            case 1:
                month = "Gennaio";
                break;
            case 2:
                month = "Febbraio";
                break;
            case 3:
                month = "Marzo";
                break;
            case 4:
                month = "Aprile";
                break;
            case 5:
                month = "Maggio";
                break;
            case 6:
                month = "Giugno";
                break;
            case 7:
                month = "Luglio";
                break;
            case 8:
                month = "Agosto";
                break;
            case 9:
                month = "Settembre";
                break;
            case 10:
                month = "ottobre";
                break;
            case 11:
                month = "Novembre";
                break;
            case 12:
                month = "Dicemebre";
                break;
            default:
                return month;
        }

        return month;
    }

}
